<template>
    <div>
        <header class="bg-gray-100 text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 flex flex-col md:flex-row-reverse" style="max-width: 1800px">
                <div class="md:w-72 mb-12 md:mb-0 md:ml-8 lg:ml-12">
                    <img src="https://insync.software/mobile-img/logo.svg" class="h-12">
                    <div class="mt-4">
                        <p class="font-semibold mb-1">Hambro Roofing Limited</p>
                        <p>Unit 2, 6-10 Lamson Road Rainham Essex RM13 9YY</p>
                        <p><a href="tel:01708803930">01708 803 930</a></p>
                        <p><a href="http://www.hambroroofing.com">www.hambroroofing.com</a></p>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-8">
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Date:</h2>
                            <p class="mt-1 text-gray-500">{{ moment(purchaseOrder.date).format('DD/MM/YYYY') }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Our Reference:</h2>
                            <p class="mt-1 text-gray-500">PO #{{ purchaseOrder.reference }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Supplier:</h2>
                            <p class="mt-1 text-gray-500">{{ purchaseOrder.supplier }}</p>
                        </div>
                        <div class="text-xl">
                            <h2 class="font-semibold text-gray-700">Supplier Reference:</h2>
                            <p class="mt-1 text-gray-500">{{ purchaseOrder.supplierReference }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="bg-white text-gray-700">
            <div class="w-full mx-auto p-8 lg:p-12 pb-16 lg:pb-16 flex flex-col-reverse lg:flex-row-reverse"
                 style="max-width: 1800px">
                <div class="lg:w-72 mb-12 lg:mb-0 lg:ml-12 ">
                    <div class="space-y-8 sticky top-4">
                        <div class="text-left sm:text-right lg:text-left justify-center flex" @click="download">
                            <div
                                class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 hover:text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer">
                                <i class="fas fa-file-pdf mr-2"></i>
                                Download PDF
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="text-3xl font-semibold text-gray-900"
                         v-text="'Purchase Order '+purchaseOrder.reference"></div>


                    <!-- PO section header (if applicable). -->
                    <div class="mt-2">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                            <div>
                                <label class="block text-sm font-medium text-gray-700">Supplier</label>
                                <div
                                    class="m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 bg-gray-50 whitespace-pre"
                                    :class="purchaseOrder.supplier ? 'text-gray-500' : 'text-gray-300'"
                                    v-html="purchaseOrder.supplier ? highlight(purchaseOrder.supplier) : 'No supplier'"
                                ></div>
                            </div>
                            <div>
                                <label class="block text-sm font-medium text-gray-700">Date</label>
                                <div
                                    class="m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 text-gray-500 bg-gray-50 whitespace-pre"
                                    v-html="highlight(moment(purchaseOrder.date).format('MMMM Do, YYYY'))">
                                </div>
                            </div>
                            <div>
                                <label class="block text-sm font-medium text-gray-700">Supplier Reference</label>
                                <div
                                    class="m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 bg-gray-50 whitespace-pre"
                                    :class=" purchaseOrder.supplierReference ? 'text-gray-500' : 'text-gray-300'"
                                    v-html="purchaseOrder.supplierReference ? highlight(purchaseOrder.supplierReference) : 'No supplier reference'">
                                </div>
                            </div>
                            <div v-if="!perItemToggle">
                                <label class="block text-sm font-medium text-gray-700">Package</label>
                                <div
                                    class="p-1 relative rounded-md block w-full border sm:text-sm bg-gray-50 border-gray-300 placeholder-gray-400 mt-1 shadow-sm form-control">
                                    <div class="flex truncate my-0">
                                        <div
                                            class="px-1.5 py-0.5 text-blue-600 ml-1 my-0.5 truncate whitespace-nowrap">
                                            <span class="fas mr-1"
                                                  :class="allPackageReference ? 'fa-cube' : 'fa-warehouse'"></span>
                                            <span
                                                v-text="allPackageReference ? allPackageName : 'Not related to a package'"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!perItemToggle">
                                <label
                                    class="block text-sm font-medium text-gray-700">{{ (!allDeliveryOption || allDeliveryOption.isDelivery ? 'Delivery' : 'Collection') }}
                                    Address</label>
                                <div
                                    class="p-1 relative rounded-md block w-full border sm:text-sm bg-gray-50 border-gray-300 placeholder-gray-400 mt-1 shadow-sm form-control">
                                    <div class="flex truncate my-0">
                                        <div
                                            class="px-1.5 py-0.5 ml-1 my-0.5 truncate whitespace-nowrap">
                                <span class="fas mr-1"
                                      :class=" !allDeliveryOption ? 'fa-question text-gray-400' : allDeliveryOption.isDelivery ? 'fa-truck text-blue-500' : 'fa-people-carry text-blue-500'">
                                </span>
                                            <span
                                                :class="(allDeliveryOption && allDeliveryOption.address ? 'text-blue-500' : 'text-gray-400')">
                                    <template v-if="allDeliveryOption && allDeliveryOption.address">
                                        <span class="pr-1"
                                              v-for="line in addressLines(allDeliveryOption)"
                                              v-text="line">
                                        </span>
                                    </template>
                                    <div v-else class="inline-block">No address set</div>
                                    <span class="pr-1"
                                          v-if="allDeliveryOption && allDeliveryOption.contactName">-</span>
                                    <span class="mx-0"
                                          v-if="allDeliveryOption && allDeliveryOption.contactName"
                                          v-text="allDeliveryOption.contactName +'(' +allDeliveryOption.contactNumber +')'"
                                    ></span>
                                  </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!perItemToggle">
                                <label class="block text-sm font-medium text-gray-700">Requested Delivery Date</label>
                                <div
                                    class="p-1 relative rounded-md block w-full border sm:text-sm bg-gray-50 border-gray-300 placeholder-gray-400 mt-1 shadow-sm form-control">
                                    <div class="flex truncate my-0">
                                        <div
                                            class="px-1.5 py-0.5 text-blue-600 ml-1 my-0.5 truncate whitespace-nowrap"
                                        >
                                            <div class="relative inline">
                                                <ui-date-picker
                                                    v-model="allDate"
                                                    ref="datepicker"
                                                    :with-time="false"
                                                    class="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                                    field="absolute top top-0 left-0 opacity-0 block max-h-4 max-w-0 overflow-hidden"
                                                ></ui-date-picker>
                                                <span
                                                    :class="(allDeliveryOption && allDeliveryOption.date ? 'text-blue-500' : 'text-blue-500') "
                                                    v-text="(allDeliveryOption && allDeliveryOption.date) ? moment(allDeliveryOption.date).format('MMMM Do, YYYY') : 'ASAP'">
                                        </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ################################### ADDITIONAL INFO -->
                        <div class="mt-6">
                            <div class="col-span-full"
                            <label class="block text-sm font-medium text-gray-700 mb-1"
                                   v-text="'Additional Information'">
                            </label>
                            <div
                                class="min-h-[76px] m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 text-gray-500 bg-gray-50 whitespace-pre"
                                v-html="highlight(purchaseOrder.additionalInformation)">
                            </div>
                        </div>
                    </div>
                    <!-- ################################### FILES -->
                    <div class="mt-6" v-if="getPoFiles().length">
                        <div class="text-xl font-semibold text-gray-900 mt-4 mb-4">Purchase Order files</div>
                        <ui-input-file-inline name="media[]"
                                              :readonly="true"
                                              :downloadUrl="downloadUrl"
                                              :current-files="getPoFiles"></ui-input-file-inline>
                    </div>

                    <!-- ################################### ITEMS -->
                    <div class="mt-6">
                        <label class="block text-sm font-medium text-gray-700">Items</label>
                        <div
                            class="flex border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                            <div class="w-6 flex-shrink-0"></div>
                            <div class="w-8 -ml-px border-r border-gray-200 px-1.5 py-1">
                                #
                            </div>
                            <div class="flex-1 border-r border-gray-200 px-2 py-1 min-w-24">
                                Description
                            </div>
                            <div class="w-16 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Qty
                            </div>
                            <div class="w-16 -ml-px border-r border-gray-200 px-1.5 py-1">
                                UoM
                            </div>
                            <div class="w-24 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Rate
                            </div>
                            <div class="w-24 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Net
                            </div>
                            <div class="w-24 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Discount
                            </div>
                            <div class="w-16 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Vat %
                            </div>
                            <div class="w-24 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Vat
                            </div>
                            <div class="w-24 -ml-px border-r border-gray-200 px-1.5 py-1">
                                Total
                            </div>
                            <div class="w-6 flex-shrink-0"></div>
                        </div>
                        <template v-if="!purchaseOrder.useGroups">
                            <purchase-order-external-item v-for="(item, index) in purchaseOrder.items"
                                                          :readonly="true"
                                                          :highlight="highlight"
                                                          :index="index"
                                                          :item="item"
                                                          :addresses="addresses"
                                                          :purchase-order="purchaseOrder"
                                                          :showDeliveryOptions="perItemToggle"
                                                          ref="items"
                                                          :key="item.id">
                            </purchase-order-external-item>
                        </template>
                        <template v-else>
                            <div class="mt-6 mb-6" v-for="(task,tIndex) in purchaseOrder.tasks">
                                <div class="flex-1 -mb-px flex border-t bg-blue-50">
                                    <div class="w-6 flex-shrink-0 py-1.5 my-px bg-blue-50">
                                        <div class="w-5 h-5 flex items-center">
                                        </div>
                                    </div>
                                    <div
                                        class="text-sm -ml-px my-px px-2 pt-1.5 pb-2 shadow-none relative hover:z-0 focus:z-30 resize-none font-bold text-gray-900 whitespace-pre-wrap bg-blue-50"
                                        v-text="task"
                                    >
                                    </div>
                                    <div class="w-6 flex-shrink-0 py-1.5 my-px bg-blue-50">
                                    </div>
                                </div>
                                <purchase-order-external-item v-for="(item, index) in purchaseOrder.items"
                                                              v-if="item.task === tIndex"
                                                              :readonly="true"
                                                              :highlight="highlight"
                                                              :index="index"
                                                              :item="item"
                                                              :addresses="addresses"
                                                              :purchase-order="purchaseOrder"
                                                              :showDeliveryOptions="perItemToggle"
                                                              ref="items"
                                                              :key="item.id">
                                </purchase-order-external-item>
                            </div>
                        </template>
                        <div class="flex h-[1px] border-t"></div>
                        <div class="flex">
                            <div class="flex flex-grow py-1.5 -my-px"></div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b">Net</div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b" v-text="purchaseOrder.netTotal"></div>
                            <div class="w-6 flex-shrink-0 self-start pt-2 -my-px pl-1 pr-1"></div>
                        </div>
                        <div class="flex">
                            <div class="flex flex-grow py-1.5 -my-px"></div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b">VAT</div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b" v-text="purchaseOrder.vatTotal"></div>
                            <div class="w-6 flex-shrink-0 self-start pt-2 -my-px pl-1 pr-1"></div>
                        </div>
                        <div class="flex">
                            <div class="flex flex-grow py-1.5 -my-px"></div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b">Gross</div>
                            <div class="w-24 -ml-px px-1.5 py-1 border-b" v-text="purchaseOrder.total"></div>
                            <div class="w-6 flex-shrink-0 self-start pt-2 -my-px pl-1 pr-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import moment from "moment";
import UiInputFileInline from "../../../filesystem/inline/UiInputFileInline.vue";
import {isNull} from "lodash";
import {ExternalPurchaseOrder} from "@models";
import UiDatePicker from "../../../ui/UiDatePicker.vue";
import PurchaseOrderExternalItem from "./PurchaseOrderExternalItem.vue";

export default {
    components: {PurchaseOrderExternalItem, UiDatePicker, UiInputFileInline},
    props: {
        purchaseOrder: null,
    },
    data() {
        return {
            purchaseOrderModel: null,
            perItemToggle: false,
            allDeliveryOption: null,
            allPackageReference: null,
            allPackageName: null,
            allDate: null,
            defaultItem: {},
            moment,
            search: "",
            addresses: [],
        };
    },
    computed: {},
    methods: {
        loadAllDeliveryOptionsFromFirstItem() {
            if (!this.purchaseOrder.items.length) {
                if (this.defaultItem) {
                    this.allDeliveryOption = this.defaultItem.deliveryOption;
                    this.allDate = this.defaultItem.date;
                    this.allPackageReference = this.defaultItem.packageReference
                        ? this.defaultItem.packageReference
                        : this.purchaseOrder.defaultPackageReference;
                    this.allPackageName = this.defaultItem.packageName
                        ? this.defaultItem.packageName
                        : this.purchaseOrder.defaultPackageName;
                }
                return;
            }
            this.allDeliveryOption = this.purchaseOrder.items[0].deliveryOption;
            this.allDate = this.purchaseOrder.items[0].date;
            this.allPackageReference = this.purchaseOrder.items[0].packageReference;
            this.allPackageName = this.purchaseOrder.items[0].packageName;
        },
        areAllDeliveryOptionsSame() {
            let comp = false;
            return this.purchaseOrder.items.every((item) => {
                let localComp = {
                    packageName: item.packageName,
                    packageReference: item.packageReference,
                    deliveryOption: null,
                    date: item.date,
                };
                if (item.deliveryOption) {
                    localComp.deliveryOption = {
                        isDelivery: item.deliveryOption.isDelivery,
                        address: item.deliveryOption.address,
                        contactName: item.deliveryOption.contactName,
                        contactNumber: item.deliveryOption.contactNumber,
                    };
                }
                if (!comp) {
                    comp = JSON.stringify(localComp);
                }
                return JSON.stringify(localComp) === comp;
            });
        },
        addressLines(deliveryOption) {
            let data = deliveryOption.address.trim();
            data = data.replace(/\n/g, ", ").trim();
            data = data.replace(/, ,/g, "").split(", ");
            let option = data.splice(-1, 1);
            data = data.map((item) => {
                return item.trim() + ",";
            });
            if (option.length > 0) {
                data.push(option[0]);
            }
            return data;
        },
        highlight(string) {
            string = "" + string;
            if (
                !string ||
                !(typeof string === "string" || string instanceof String)
            ) {
                return "&nbsp;";
            }
            let htmlSafe = string.replace(
                /[\u00A0-\u9999<>\&;0123456789#]/g,
                (i) => "&#" + i.charCodeAt(0) + ";"
            );
            if (this.search.trim() === "") {
                return htmlSafe;
            }
            let search = this.search
                .toLowerCase()
                .replace(
                    /[\u00A0-\u9999<>\&;0123456789#]/g,
                    (i) => "&#" + i.charCodeAt(0) + ";"
                );
            const query = search.split(/[\s]+/).filter((item) => {
                return item.trim() !== "";
            });
            let reg = new RegExp(query.join("|"), "gi");
            let res = htmlSafe.replace(reg, "<span class='bg-blue-200'>$&</span>");
            if (res === "<span class='bg-blue-200'></span>") {
                return "&nbsp;";
            }

            return res;
        },
        calculateAddress(allowBlank = false) {
            let s = [];
            this.purchaseOrder.items.concat([this.defaultItem]).forEach((item) => {
                if (item.deliveryOption && !isNull(item.deliveryOption.address)) {
                    let i = s.find(
                        (i) =>
                            i.address === item.deliveryOption.address &&
                            i.contactName === item.deliveryOption.contactName &&
                            i.contactNumber === item.deliveryOption.contactNumber
                    );
                    if (!i) {
                        i = {
                            address: item.deliveryOption.address,
                            contactName: item.deliveryOption.contactName,
                            contactNumber: item.deliveryOption.contactNumber,
                            items: [],
                        };
                        s.push(i);
                    }
                    i.items.push(item);
                }
            });
            this.addresses = s;
        },
        download() {
            window.location.href = this.purchaseOrderModel.getDownloadUrl()
        },
        downloadUrl(id) {
            return route('api.v2.external.purchase-order.file.download', {
                'id': this.purchaseOrder.id,
                'file_id': id
            }) + '?jwt=' + ((window.auth && window.auth.token) ? window.auth.token : '')
        },
        getPoFiles() {
            return this.purchaseOrder.files
        },

    },
    async mounted() {
        this.purchaseOrderModel = ExternalPurchaseOrder.make(this.purchaseOrder);
        this.loadAllDeliveryOptionsFromFirstItem();
        this.perItemToggle = !this.areAllDeliveryOptionsSame();
        this.calculateAddress(false);
    },
};
</script>